// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardContent_cls1__nBloH","cls2":"VeloCardContent_cls2__T42sQ VeloCardContent_cls1__nBloH","slimline":"VeloCardContent_slimline__SY5xx"};